import React, { useState } from "react";
import { Phone, Clock, MapPin, Menu, X } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="bg-white/95 backdrop-blur-sm shadow-sm fixed w-full top-0 z-50 transition-all duration-300">
      {/* Top info bar */}
      <div className="bg-sage-soft text-sage-dark py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center text-sm">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-1">
              <Phone className="w-4 h-4" />
              <span>253 279 717</span>
            </div>
            <div className="flex items-center space-x-1">
              <MapPin className="w-4 h-4" />
              <span>R. de Santo André 51, Braga</span>
            </div>
          </div>
          <div className="flex items-center space-x-1">
            <Clock className="w-4 h-4" />
            <span>Ter-Sáb: 09:30-19:00</span>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/l9ztlh72_2023-06-03.webp"
              alt="Fonte de Juvence Logo"
              className="h-12 w-auto mr-3"
            />
            <h1 className="text-2xl font-playfair font-bold text-sage-dark">
              Fonte de Juvence
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-sage-dark hover:text-gold-warm transition-colors duration-200"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('sobre')}
              className="text-sage-dark hover:text-gold-warm transition-colors duration-200"
            >
              Sobre Nós
            </button>
            <button 
              onClick={() => scrollToSection('servicos')}
              className="text-sage-dark hover:text-gold-warm transition-colors duration-200"
            >
              Serviços
            </button>
            <button 
              onClick={() => scrollToSection('precos')}
              className="text-sage-dark hover:text-gold-warm transition-colors duration-200"
            >
              Preços
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="text-sage-dark hover:text-gold-warm transition-colors duration-200"
            >
              Contacto
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-sage-dark"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 py-4 border-t border-sage-soft">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-sage-dark hover:text-gold-warm transition-colors duration-200 text-left"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('sobre')}
                className="text-sage-dark hover:text-gold-warm transition-colors duration-200 text-left"
              >
                Sobre Nós
              </button>
              <button 
                onClick={() => scrollToSection('servicos')}
                className="text-sage-dark hover:text-gold-warm transition-colors duration-200 text-left"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('precos')}
                className="text-sage-dark hover:text-gold-warm transition-colors duration-200 text-left"
              >
                Preços
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="text-sage-dark hover:text-gold-warm transition-colors duration-200 text-left"
              >
                Contacto
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;